import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import PhotoGallery from "components/photo/PhotoGallery";

import "./ArticleDetail.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  fetchArticleAttribute,
  fetchArticleDetail,
} from "store/articleDetail/articleDetail.slice";
import {
  LoadingOutlined,
  MinusOutlined,
  PlusOutlined,
  ShoppingCartOutlined,
  StarOutlined,
} from "@ant-design/icons";
import { addArticle } from "store/cart/cart.slice";
import { BreadcrumbLink } from "components";
import { useTranslation } from "react-i18next";
import { Avatar, Breadcrumb, InputNumber, Rate, Tooltip } from "antd";
import ShareIcons from "components/shareIcons/ShareIcons";
import { setSEO } from "utils/helpers/seo-function";

import "utils/helpers/ToastHelper.scss";
import { showToast } from "utils/helpers/toastHelper";
import { useEffectDeviceAndOrientation } from "utils/hooks";
import { BASE_URL } from "config/constants";
import { IoCall } from "react-icons/io5";
import { CURRENCY } from "utils/textConstants";
import CartButton from "./CartButton";
import SkeletonContainer from "components/skeleton/SkeletonContainer";
import RateComponent from "components/rate/RateComponent";
import FavoriteButtonComponent from "components/favoriteButton/FavoriteButtonComponent";
import RecentArticles from "../recentArticles/RecentArticles";
import Baners from "../baners/Baners";
import { trackEcommerceEvent } from "utils/helpers/analytics";

const ArticleDetail = () => {
  const { t } = useTranslation("home", { useSuspense: false });
  const [device, orientation] = useEffectDeviceAndOrientation();
  const { pathname } = useLocation();
  const dispatch: any = useDispatch();
  let { articleSlug } = useParams();
  const { articleDetail, articleAttribute } = useSelector(
    (store: any) => store.articleDetail
  );

  const [count, setCount] = useState<number>(1);
  const navigate = useNavigate();

  const handleCount = (value: number | null) => {
    if (value !== null) {
      setCount(Math.floor(Number(value)));
    } else {
      setCount(1);
    }
  };

  const addToCart = (e: any) => {
    dispatch(
      addArticle({
        price: articleDetail.data.article_price.price,
        discount: articleDetail.data.article_price.discount,
        old_price: articleDetail.data.article_price.old_price,
        slug: articleDetail.data.article_slug,
        name: articleDetail.data.article_name,
        image: articleDetail.data.images[0],
        quantity: count,
      })
    );
    showToast(`Proizvod dodat u korpu`, "success");

    trackEcommerceEvent("add_to_cart", {
      currency: "BAM",
      value: articleDetail.data.article_price.price * count,
      items: [
        {
          item_id: articleDetail.data.article_slug,
          item_name: articleDetail.data.article_name,
          quantity: count,
          price: articleDetail.data.article_price.price,
        },
      ],
    });
  };

  const setSEOToArticle = (ac: any) => {
    setSEO({
      title: ac.article_name !== null ? ac.article_name : "",
      description:
        ac.article_short_description !== null
          ? ac.article_short_description
          : "",
      keywords: ac.seo_keywords !== null ? ac.seo_keywords : [],
      url: BASE_URL + pathname,
      image: ac.images[0] !== null ? ac.images[0] : "",
      type: "article",
    });
  };

  useEffect(() => {
    let script: any;
    let script2: any;
    let script3: any;
    if (articleSlug !== "" && articleSlug) {
      dispatch(fetchArticleAttribute(articleSlug));
      dispatch(fetchArticleDetail(articleSlug)).then((rez: any) => {
        if (rez.type === "articleDetail/fetchSArticleDetail/fulfilled") {
          setSEOToArticle(rez.payload);

          // document.querySelector
          if (
            !document.querySelector(
              `script[src="https://api.infocomp.shoply.ba/chat/script"]`
            )
          ) {
            // SHOPLY CHAT
            script = document.createElement("script");
            script.textContent = `window.shoply = { onLoad: function () { window.shoply.showMiniChat({sku:  ${JSON.stringify(
              rez.payload.sku
            )} }) }}; `;
            document.body.appendChild(script);
            script2 = document.createElement("script");
            script2.src = "https://api.infocomp.shoply.ba/chat/script";
            script2.crossOrigin = "anonymous";
            script2.async = true;
            document.body.appendChild(script2);
          } else {
            script3 = document.createElement("script");
            script3.textContent = `
            window.shoply.showMiniChat({sku: ${JSON.stringify(
              rez.payload.sku
            )}});
            `;
            document.body.appendChild(script3);
          }
        }
      });
    }

    return () => {
      if (script3) {
        document.body.removeChild(script3);
      }
      // if (script2) {
      //   document.body.removeChild(script2);
      // }
      // document.getElementById("__shoply-mini-chat-root__")?.remove();
    };
  }, [dispatch, pathname]);

  const getBreadcrumbItems = () => {
    let list = [
      {
        title: (
          <BreadcrumbLink
            label={t("pocetna")}
            path={"/"}
            title={t("pocetna")}
          />
        ),
      },
      {
        title: (
          <BreadcrumbLink
            label={
              device === "computer" && orientation === "landscape"
                ? t("proizvodi")
                : "..."
            }
            path={"/articles"}
            title={t("proizvodi")}
          />
        ),
      },
    ];
    if (articleDetail.is_fetch === true) {
      for (let i = 0; i < articleDetail.data.breadcrumb.length; i++) {
        if (
          i === articleDetail.data.breadcrumb.length - 1 ||
          (device === "computer" && orientation === "landscape")
        ) {
          list.push({
            title: (
              <BreadcrumbLink
                label={articleDetail.data.breadcrumb[i].ac_name}
                path={`/articles${articleDetail.data.breadcrumb[i].path}`}
                title={articleDetail.data.breadcrumb[i].ac_name}
              />
            ),
          });
        } else {
          list.push({
            title: (
              <BreadcrumbLink
                label={"..."}
                path={`/articles${articleDetail.data.breadcrumb[i].path}`}
                title={articleDetail.data.breadcrumb[i].ac_name}
              />
            ),
          });
        }
      }
    }

    return list;
  };

  return (
    <div className="Page">
      <div className="Page-Content">
        <Breadcrumb items={getBreadcrumbItems()} />

        <div className="Article-Detail-Box">
          {articleDetail.is_fetch ? (
            <div className="Article-Detail-Photo">
              <PhotoGallery
                images={articleDetail.data.images}
                type={"article"}
              />
            </div>
          ) : (
            <SkeletonContainer className="Article-Detail-Photo" />
          )}
          {articleDetail.is_fetch ? (
            <div className="Article-Detail-Info">
              <h1 className="Article-Title">
                {articleDetail.data.article_name}
              </h1>
              {articleDetail.data.vendor.vendor_url !== null && (
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  to={articleDetail.data.vendor.vendor_url}
                >
                  <label
                    className="Vendor-Link"
                    title={articleDetail.data.vendor.vendor_name}
                  >
                    {articleDetail.data.vendor.vendor_name}
                  </label>
                </Link>
              )}

              <p className="Article-Description">
                {articleDetail.data.article_short_description}
              </p>
              <p>
                Stanje: <strong>{articleDetail.data.article_state}</strong>{" "}
              </p>

              <div className="Article-Rate">
                <RateComponent
                  slug={articleDetail.data.article_slug}
                  currentRate={articleDetail.data.avg_rate}
                />
              </div>

              {articleDetail.data.article_price.is_visible ? (
                <>
                  {articleDetail.data.article_price.on_sale && (
                    <label className="Article-Old-Price">
                      {articleDetail.data.article_price.old_price} {CURRENCY}
                    </label>
                  )}
                  <h2 className="Article-Price">
                    {articleDetail.data.article_price.price} {CURRENCY}
                  </h2>
                  {articleDetail.data.article_price.on_sale && (
                    <label className="Article-Discount-Price">
                      Ušteda{" "}
                      {(
                        articleDetail.data.article_price.old_price -
                        articleDetail.data.article_price.price
                      ).toFixed(2)}{" "}
                      {CURRENCY}
                    </label>
                  )}
                  <div>
                    <label>*Cijene su sa uračunatim PDV-om</label>
                  </div>
                  <div className="Article-Detail-Quantity">
                    <div>Količina:</div>
                    <div className="Article-Detail-Buttons">
                      <CartButton
                        count={count}
                        setCount={setCount}
                        handleCount={handleCount}
                      />

                      <button
                        onClick={addToCart}
                        className="Add-To-Cart-Button"
                        disabled={count === 0}
                      >
                        <ShoppingCartOutlined />
                        {t("dodaj_u_korpu")}
                      </button>
                      <FavoriteButtonComponent
                        slug={articleDetail.data.article_slug}
                        currentFavorite={articleDetail.data.is_favorite}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <div className="Article-Detail-Contact">
                  <h4 className="Contact-Label">{t("cijena_na_upit")}</h4>
                  <button
                    onClick={() => navigate("/contact")}
                    className="Contact-Button"
                  >
                    <IoCall />
                    &nbsp; Kontaktirajte nas
                  </button>
                  <FavoriteButtonComponent
                    slug={articleDetail.data.article_slug}
                    currentFavorite={articleDetail.data.is_favorite}
                  />
                </div>
              )}

              <ShareIcons
                url={pathname}
                title={articleDetail.data.article_name}
                summary={articleDetail.data.article_description}
              />
            </div>
          ) : (
            <SkeletonContainer className="Article-Detail-Info-Skeleton" />
          )}
        </div>
        <div className="Article-Detail-Box">
          {articleAttribute.is_fetch ? (
            articleAttribute.data &&
            articleAttribute.data.length !== 0 && (
              <div className="Article-Detail-Parameters">
                <h3>Specifikacija:</h3>
                <div className="Article-Detail-Parameters-List">
                  {articleAttribute.data.map((attribute: any, y: any) => (
                    <div
                      className="Article-Detail-Parameters-List-Item"
                      key={y}
                    >
                      <div>
                        <p>{attribute.attribute_name}:</p>
                      </div>
                      <div>
                        <p>
                          {attribute.attribute_value
                            ? attribute.attribute_value
                            : "-"}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
          ) : (
            <SkeletonContainer className="Article-Detail-Parameters" />
          )}
          {articleDetail.is_fetch ? (
            <div className="Article-Detail-Description">
              <h3>Detaljan opis:</h3>
              <div
                className="Article-Description"
                dangerouslySetInnerHTML={{
                  __html: articleDetail.data.article_description,
                }}
              ></div>
            </div>
          ) : (
            <SkeletonContainer className="Article-Detail-Description" />
          )}
        </div>
        {articleDetail.is_fetch && (
          <RecentArticles
            slug={articleDetail.data.ac_slug}
            title={"Najpopularniji proizvodi"}
          />
        )}

        <Baners />
      </div>
    </div>
  );
};
export default ArticleDetail;
